import * as angular from 'angular';
import { Observable } from 'rxjs';
import { combineLatest, filter, map, switchMap } from 'rxjs/operators';
import { isPresent } from '@mode/shared/util-js';

import { EmbedActions } from '@mode/reports/sandbox/contract';
import { TableView } from '@mode/legacy/data-access-model-js';
import { EmbedReportState, ReportStore } from '@mode/reports/sandbox/contract';
import { MixableBaseController } from '../../../common/component';
import { EmbedReportSelectors, EmbedTableSelectors } from '../domain/embed-report.selectors';

class ModeTableController extends MixableBaseController {
  static $inject = ['RxStoreService'];

  id: string;
  token: string;

  dataset$: Observable<EmbedReportState.EmbedDataset>;
  view$: Observable<TableView>;

  viewer$: Observable<string>;
  isVegasChart$: Observable<boolean>;
  isPivotTable$: Observable<boolean>;
  isBigNumber$: Observable<boolean>;
  showPlaceholder$: Observable<boolean>;
  showTable$: Observable<boolean>;
  tableTitle$: Observable<string>;

  constructor(private rxStore: ReportStore) {
    super();
  }

  $onInit() {
    this.token = this.id.split('_')[1];
    this.view$ = this.rxStore.select(EmbedTableSelectors.createTableViewSelector(this.token));
    this.dataset$ = this.rxStore.select(EmbedTableSelectors.createQueryTokenSelector(this.token)).pipe(
      filter(isPresent),
      switchMap((queryToken) => this.rxStore.select(EmbedReportSelectors.createDatasetSelector(queryToken)))
    );

    this.viewer$ = this.rxStore.select(EmbedReportSelectors.viewerType);
    this.showPlaceholder$ = this.dataset$.pipe(
      combineLatest(this.view$),
      map(([ds, view]) => ds == null && view != null)
    );
    this.showTable$ = this.dataset$.pipe(
      combineLatest(this.view$),
      map(([ds, view]) => ds != null && view != null)
    );
    this.tableTitle$ = this.dataset$.pipe(map((ds) => (ds && ds.queryName ? ds.queryName : '')));
  }

  onAction($action: EmbedActions) {
    this.rxStore.dispatch($action);
  }
}

export const ModeTableComponent: angular.IComponentOptions = {
  bindings: {
    id: '@',
  },
  controller: ModeTableController,
  controllerAs: 'ctrl',
  template: `
  <viz-placeholder
    ng-if="ctrl.showPlaceholder$ | async:this"
    is-loading="ctrl.showPlaceholder$ | async:this"
    viz-title="ctrl.tableTitle$ | async:this"
    viz-type="'chart'"
    chart-type="'table'"
  ></viz-placeholder>
  <table-renderer
    id="{{ ctrl.id }}"
    ng-if="ctrl.showTable$ | async:this"
    dataset="ctrl.dataset$ | async:this"
    set-view="ctrl.view$ | async:this"
    on-action="ctrl.onAction($action)"
    viewer="::ctrl.viewer$ | async:this"
  ></table-renderer>
  `,
};
